module.exports = __webpack_public_path__ + "img/ic-warning.5d5919ff.png";